// One settle physics for the app: integrated ahead of time and handed to the compositor as keyframes, so a long
// main-thread task cannot starve it the way a CSS curve resembling it would.

// Relative, not aliased: this module is unit-tested, and the pure-node test runner resolves no `@/` alias.
import { SPRING_HZ, SPRING_TRAJECTORY } from '../components/custom/route-transition/core/spring'

// Re-exported, not re-integrated, so the sheet, the nav stack and the surface engine share ONE array.
export { SPRING_TRAJECTORY }

// The sample count IS the duration, so the animation cannot drift out of step with the curve it runs.
export const SPRING_DURATION_MS = Math.round((SPRING_TRAJECTORY.length / SPRING_HZ) * 1000)

// `linear` is not a curve choice — the samples ARE the curve, and any easing on top would bend the physics.
export const SPRING_OPTIONS: KeyframeAnimationOptions = {
  duration: SPRING_DURATION_MS,
  easing: 'linear',
  fill: 'forwards',
}

/** The spring, in the caller's units: one value per keyframe, from `from` to `to`. */
export function springValues(from: number, to: number): number[] {
  return SPRING_TRAJECTORY.map((progress) => from + (to - from) * progress)
}
